import moment from "moment";
import React from "react";
import { SocialNetworkPosted, SourceType } from "@/interfaces";
import { SocialCoachSession } from "@/services/bedrock";
import { URLS } from "@/utils";

export const wrapInLinkIfHrefIsPresent = (href: string | undefined, children: React.ReactNode): React.ReactNode => {
  if (!href) return children;
  return (
    <a className="externalLink" href={href} onClick={e => e.stopPropagation()} target="_blank">
      {children}
    </a>
  );
};

export const formatDate = (date: string | null | undefined) => {
  return date ? moment(date).format("MM/DD/YYYY hh:mm a") : "";
};

export const getUrlForSource = (
  session: SocialCoachSession | undefined,
  sourceType: SourceType,
  sourceId: number
): string | undefined => {
  if (!session) return undefined;
  const isPlayer = session?.userRole == "PLAYER";
  const isCoach = session?.userRole == "COACH" || session?.userRole == "ASSISTANT_COACH";
  const isAdmin = session?.userRole == "ADMIN";

  switch (sourceType) {
    case "CAMPAIGN":
      if (isCoach) return URLS.coach.editCampaigns.replace(":campaignId", sourceId.toString());
      return undefined;
    case "VIDEO_PROJECT":
      if (isAdmin) return URLS.editor.videoProjects.detail.replace(":id", sourceId.toString());
      if (isPlayer) return URLS.player.videoProject.replace(":id", sourceId.toString());
      return URLS.coach.videoProject.replace(":id", sourceId.toString());
    case "PROMPT":
      return getUrlForPrompt(session, sourceId);
    case "CONTENT_PAGE":
      if (isPlayer) return URLS.player.videoPages;
      return undefined;
    case "BLOG":
      if (isPlayer) return URLS.player.blog.replace(":id", sourceId.toString());
      if (isCoach) return URLS.coach.blog.replace(":id", sourceId.toString());
      return undefined;
    case "POST":
    default:
      return undefined;
  }
};

export const getUrlForPlayer = (
  session: SocialCoachSession | undefined,
  playerId: string | number | undefined
): string | undefined => {
  if (!session || playerId === undefined) return undefined;
  if (session?.userRole == "COACH" || session?.userRole == "ASSISTANT_COACH")
    return URLS.coach.editPlayer.replace(":playerId", playerId.toString());
  return undefined;
};

export const getUrlForPrompt = (
  session: SocialCoachSession | undefined,
  promptId: string | number | undefined
): string | undefined => {
  if (!session || promptId === undefined) return undefined;
  if (session?.userRole == "COACH" || session?.userRole == "ASSISTANT_COACH")
    return URLS.coach.prompt.replace(":promptId", promptId.toString());
  if (session?.userRole == "PLAYER") return URLS.player.prompts;
  return undefined;
};

export const getUrlForSocialNetwork = (sn: SocialNetworkPosted): string | undefined => {
  if (sn.status !== "POSTED" || sn.externalPostUrl === undefined) return undefined;

  if (sn.socialNetworkId === "FB") {
    return sn.externalPostUrl;
  } else {
    return sn.externalPostUrl
      .replace("[", "")
      .replace("]", "")
      .split('"')
      .reduce((result, item) => {
        return `${result}${item}`;
      });
  }
};
